<template>
    <b-card no-body>
        <b-card-header class="border-0">
            <h3 class="mb-0"> {{ $t('egresos') }}</h3>
        </b-card-header>
        <b-row class="ml-3 justify-content-start align-items-start">
            <b-col v-if="this.filter.grupoEstado == 4" md="3" class="estadoPago">
                <b-form-group :label="$t('estado_pago')" >
                    <b-form-select id="estadopago-filter" v-model="filter.estadoPago" >
                        <option :value="null"> {{ $t('seleccione_opcion') }} </option>
                        <option v-for="option in estadoPagoOptions" :key="option.value" :value="option.value">
                            {{ option.text }}
                        </option>
                    </b-form-select>
                </b-form-group>
            </b-col>

            <b-col md="3">
                <b-form-group label="Material Recibido" label-for="materiales">
                    <template v-slot:label>
                        {{ $t('material_recibido') }} <span class="text-danger">*</span>
                    </template>
                    <el-select multiple class="custom-input" v-model="filter.materiales" filterable
                        :placeholder="$t('materiales')" style="width: 100%;">
                        <el-option v-for="item in materialOptions" :key="item.value" :label="item.text"
                            :value="item.value" />
                    </el-select>
                </b-form-group>
            </b-col>

            <b-col v-if="rol === 'admin' && false" md="2">
                <b-form-group label-for="folio">
                    <template v-slot:label>
                        {{ $t('folio') }} <span class="text-danger">*</span>
                    </template>
                    <b-form-input v-model="filter.numeroFolio" type="number" :placeholder="$t('folio')"
                        @input="onPlantaChange"></b-form-input>
                </b-form-group>
            </b-col>

            <b-col v-if="rol === 'admin' && false" md="2">
                <b-form-group label-for="filtro actas">
                    <template v-slot:label>
                        {{ $t('filtrar_por_actas') }}
                    </template>
                    <div>
                        <b-form-checkbox v-model="filter.hasActa" :value="true" unchecked-value="null">
                            {{ $t('solo_con_actas') }}
                        </b-form-checkbox>
                        <b-form-checkbox v-model="filter.hasActa" :value="false" unchecked-value="null">
                            {{ $t('todos') }}
                        </b-form-checkbox>
                    </div>
                </b-form-group>
            </b-col>


            <b-col md="2">
                <b-form-group label-for="planta">
                    <template v-slot:label>
                        {{ $t('planta') }} <span class="text-danger">*</span>
                    </template>                   
                    <el-select class="custom-input" v-model="filter.planta" filterable clearable  @change="onPlantaChange"
                        :placeholder="($t('seleccione') + ' ' + $t('plantas'))" style="width: 100%;">
                        <el-option v-for="item in plantaOptions" :key="item.value" :label="item.text"
                            :value="item.value" />
                    </el-select>
                </b-form-group>
            </b-col>

            <b-col md="2">
                <b-form-group label="Material Recibido" label-for="materiales">
                    <template v-slot:label>
                        {{ $t('pasillo') }} 
                    </template>
                    <el-select multiple class="custom-input" :disabled="!isPlantaSelected" v-model="filter.pasillos"
                        filterable :placeholder="($t('seleccione') + ' ' + $t('pasillos'))" style="width: 100%;">
                        <el-option v-for="item in pasilloOptions" :key="item.value" :label="item.text"
                            :value="item.value" />
                    </el-select>
                </b-form-group>
            </b-col>

            <b-col md="2">
                <b-form-group label-for="folio">
                    <template v-slot:label>
                        {{ $t('guia_traslado') }}
                    </template>
                    <b-form-input v-model="filter.guiaTraslado" type="number" :placeholder="$t('guia_traslado')"
                        @input="onPlantaChange"></b-form-input>
                </b-form-group>
            </b-col>

            <b-col v-if="rol === 'admin'" md="2">
                <b-form-group label-for="egreso">
                    <template v-slot:label>
                        {{ 'N° '+ $t('egreso') }}
                    </template>
                    <b-form-input v-model="filter.egreso" type="number" :placeholder="'N° '+ $t('egreso')"></b-form-input>
                </b-form-group>
            </b-col>
        

        
            <b-col md="2">
                <b-form-group label="Empresa" label-for="empresaID">
                    <template v-slot:label>
                        {{ $t('empresa') }}
                    </template>
                    <el-select class="custom-input" v-model="filter.empresa" filterable clearable
                        :placeholder="$t('materiales')" style="width: 100%;">
                        <el-option v-for="item in empresaOptions" :key="item.value" :label="item.text"
                            :value="item.value" />
                    </el-select>
                </b-form-group>
            </b-col>

            <b-col md="2" v-if="!exportMode">
                <b-form-group label-for="fechaInicio">
                    <template v-slot:label>
                        {{ $t('fecha_inicio') }}
                    </template>
                    <b-form-input v-model="filter.fechaInicio" type="date" placeholder="dd-mm-aaaa"></b-form-input>
                </b-form-group>
            </b-col>

            <b-col md="2" v-if="!exportMode">
                <b-form-group label-for="fechaFin">
                    <template v-slot:label>
                        {{ $t('fecha_fin') }}
                    </template>
                    <b-form-input v-model="filter.fechaFin" type="date" placeholder="dd-mm-aaaa"></b-form-input>
                </b-form-group>
            </b-col>

            <b-col md="3">
                <b-form-group label-for="orden">
                    <template v-slot:label>
                        {{ $t('ordenar_por') }}
                    </template>
                    <div>
                        <b-form-checkbox v-model="filter.OrderNuevos" :value="true" :unchecked-value="null" class="chek">
                            {{ $t('Recientes') }}
                        </b-form-checkbox>
                        <b-form-checkbox v-model="filter.OrderNuevos" :value="false" :unchecked-value="null" class="chek">
                            {{ $t('Antiguos') }}
                        </b-form-checkbox>
                    </div>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row class="ml-3 justify-content-center align-items-center">
            <b-col v-if="rol === 'admin' && !exportMode" md="auto" class="text-center">
                <b-form-group style="">
                    <b-button type="submit" @click="getAllFiltered()" variant="primary" :disabled="exportMode"
                        style="margin-top: 0px;">
                        {{ $t('buscar') }}
                    </b-button>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row
            v-if="($route.params.grupo == 4 || $route.params.grupo == 3) && rol === 'admin' && !facturaMode && !exportMode"
            class="ml-12 justify-content-start align-items-center mb-3" style="justify-content:end !important">

            <b-col md="auto" class="text-center">
                <b-form-group>
                    <b-button type="submit" @click="exportMode = true"
                        :style="{ backgroundColor: exportMode ? 'red' : 'green', color: 'white' }">
                        {{ !exportMode ? $t('exportar') : $t('cancelar') }}
                    </b-button>
                </b-form-group>
            </b-col>

            <b-col md="auto" class="text-center">
                <b-form-group>
                    <b-button type="submit" @click="facturaMode = !facturaMode"
                        :style="{ backgroundColor: facturaMode ? 'red' : 'orange', color: 'white' }">
                        {{ !facturaMode ? $t('factura') : $t('cancelar') }}
                    </b-button>

                </b-form-group>
            </b-col>
        </b-row>


        <b-row v-if="facturaMode" class="justify-content-right align-items-center">
            <b-col md="12" v-if="($route.params.grupo == 4 || $route.params.grupo == 3) && rol == 'admin'">
                <b-form-group>
                    <b-button v-if="!desvincularMode" v-b-modal.modal-factura :disabled="egresosSelected.length == 0"
                        variant="warning">
                        {{ $t('adjuntar_factura') }}
                    </b-button>
                    <b-button :disabled="egresosSelected.length == 0" v-if="desvincularMode" @click="desvincularFactura"
                        variant="info">
                        {{ $t('guardar') }}
                    </b-button>
                    <b-button @click="checkegresosValidos" :variant="!desvincularMode ? 'default' : 'danger'">
                        {{ !desvincularMode ? $t('desvincular_factura') : $t('cancelar') }}
                    </b-button>

                    <b-button v-if="!desvincularMode" type="submit" @click="cambiarModo" variant="danger">
                        {{ $t('cancelar') }}
                    </b-button>
                    <b-modal id="modal-factura" size="xl" scrollable title="Adjuntar Factura" @ok="adjuntarFactura"
                        no-close-on-backdrop :ok-title="$t('adjuntar')">
                        <b-row>
                            <b-col cols="4">
                                <b-form-group label-for="file-input"><template v-slot:label>
                                        {{ $t('documento') }}<span class="text-danger">*</span>
                                    </template>
                                    <b-form-file id="file-input" required v-model="factura.file"
                                        :browse-text="$t('adjuntar')" :state="factura.file ? true : null"
                                        accept=".jpg, .jpeg, .png, .pdf, .doc, .docx, .bmp"
                                        placeholder="Selecciona un archivo...">
                                    </b-form-file>
                                </b-form-group>
                            </b-col>

                            <b-col cols="3">
                                <b-form-group label="Número de la Factura" label-for="numero-input">
                                    <template v-slot:label>
                                        {{ $t('numero_factura') }} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-input id="numero-input" type="text" v-model="factura.numero"
                                        :state="factura.numero ? true : null" placeholder="Número de la factura">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="3">
                                <b-form-group label="Fecha" label-for="fecha">
                                    <template v-slot:label>
                                        {{ $t('fecha') }} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-input id="fecha" type="date" v-model="factura.fecha"
                                        required></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <el-table :data="egresosFactura" stripe style="width: 100%">
                            <el-table-column prop="guiaTraslado" label="Guía de Traslado"></el-table-column>
                            <el-table-column prop="material" label="Material"></el-table-column>
                            <el-table-column prop="chofer" label="Chofer"></el-table-column>

                            <el-table-column>
                                <template v-slot="{ row }">
                                    <b-button @click="deleteFromegresosSelected(row.id)" variant="danger" size="sm"
                                        class="ml-2">x</b-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </b-modal>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row v-if="exportMode" class="justify-content-end align-items-end mb-3">
            <b-col xl="2">
                <b-form-input v-model="fechaInicio" type="date" placeholder="dd-mm-aaaa" class="mb-2"></b-form-input>
            </b-col>
            <b-col xl="2">
                <b-form-input v-model="fechaFin" type="date" placeholder="dd-mm-aaaa" class="mb-2"></b-form-input>
            </b-col>
            <b-col xl="3" style="top: -8px;">
                <b-button  @click="exportPagados">{{ $t('exportar')
                    }}</b-button>

                <b-button type="submit" @click="exportMode = false" variant="danger">
                    {{ $t('cancelar') }}
                </b-button>
            </b-col>
        </b-row>
        <el-table class="table-responsive table" :data="filterTableData">
            <el-table-column
                v-if="($route.params.grupo == 4 || $route.params.grupo == 3) && rol === 'admin' && !exportMode"
                label="Seleccionar" width="130">
                <template v-slot:header>
                    <input type="checkbox" @change="toggleSelectAll" :checked="isAllSelected" /> Todos
                </template>
                <template v-slot="{ row }">
                    <input type="checkbox" :value="row.id" @change="selectionChange(row.id, $event)"
                        :disabled="desvincularMode && (row.numeroFactura == null || row.urlFactura == null)"
                        :checked="isRowSelected(row.id)" />
                </template>
            </el-table-column>

            <el-table-column v-if="($route.params.grupo == 4 || $route.params.grupo == 3) && !exportMode"
                label="Seleccionar" width="130">
                <template v-slot:header>
                    <span class="status">Factura</span>
                </template>
                <template v-slot="{ row }">
                    <FileViewer :id="row.id" :url="row.urlFactura" :mode="'min'" :filename="row.numeroFactura" />
                </template>
            </el-table-column>

            <el-table-column :label="'#'+$t('egreso')" prop="budget" min-width="150px">
                <template v-slot="{ row }">
                    <router-link :to="{ name: 'egreso-detalle', params: { id: row.id } }">
                        <span class="status">{{ row.id }}</span>
                    </router-link>
                </template>
            </el-table-column>

            <el-table-column :label="$t('g_traslado')" prop="budget" min-width="150px">
                <template v-slot="{ row }">                    
                    <span class="status">{{ row.guiaTraslado }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('patente')" min-width="120px" prop="status">
                <template v-slot="{ row }">
                    <span class="status">{{ row.patente }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('empresa')" min-width="200px" prop="status">
                <template v-slot="{ row }">
                    <span class="status">{{ row.empresa }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('material')" min-width="250px" prop="status">
                <template v-slot="{ row }">
                    <span class="status">{{ row.material }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('fecha')" min-width="170px" prop="status">
                <template v-slot="{ row }">
                    <span class="status">{{ row.fecha }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('peso')" min-width="170px" prop="status">
                <template v-slot="{ row }">
                    <span class="status">{{ row.pesoTotal }} {{ row.uom }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('precio')" min-width="170px" prop="status">
                <template v-slot="{ row }">
                    <span class="status">{{ row.precio > 0 ? Number(row.precio).toLocaleString('es-ES') : 0 }} {{
                        row.moneda
                    }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('estado_pago')" min-width="170px" prop="status">
                <template v-slot="{ row }">
                    <span class="status">{{ row.estadoPago }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('accion')" min-width="170px" prop="action">
                <template v-slot="{ row }">
                    <b-row>
                        <b-col>
                            <router-link :to="{ name: 'egreso-documentos', params: { id: row.id } }">
                                <a variant="primary" class="btn-create-new">
                                    <i class="far fa-file-image" style="color: green;"></i>
                                </a>
                            </router-link>
                        </b-col>
                        <b-col>
                            <a @click="deleteRow(row.id)" variant="primary" class="btn-create-new">
                                <i class="fas fa-trash" style="color: red; cursor: pointer;"></i>
                            </a>
                        </b-col>
                    </b-row>
                </template>
            </el-table-column>

        </el-table>
        <b-card-footer class="py-4 d-flex justify-content-end">
            <pagination v-if="total > 0" v-model="filter.page" :per-page="filter.pageSize" :total="total" @update:modelValue="changePage"
                @update:perPage="changePageSize" />
        </b-card-footer>

        <!-- <b-card-footer class="py-4 d-flex justify-content-end">
            <base-pagination v-model="page" :per-page="pageSize" :total=total></base-pagination>
        </b-card-footer>  -->

    </b-card>
</template>
<script>
import miscService from '@/api/miscService';
import egresoService from '@/api/egresoService';
import { Table, TableColumn, Select, Option } from 'element-ui'
import utilsService from '@/api/utilsService';
import FileViewer from '@/components/FileViewer';
import Pagination from '@/components/Pagination.vue';

export default {
    name: 'egresos-table',
    components: {
        FileViewer,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
        Pagination
    },
    data() {
        return {
            tableData: [],
            facturaMode: false,
            exportMode: false,
            search: '',
            total: 0,
            estadoPagoOptions: [],
            filter: {
                estadoPago: null,
                grupoEstado: 0,
                materiales: [],
                pasillos: [],
                planta: null,
                page: 1,
                pageSize: 10,
                hasActa: null,
                numeroFolio: null,
                fechaInicio: null,
                fechaFin: null,
                OrderNuevos: true,
                empresa: null,
                egreso: null
            },
            egresosSelected: [],
            materialOptions: [],
            pasilloOptions: [],
            plantaOptions: [],
            egresosFactura: [],
            empresaOptions: [],
            factura: {
                file: null,
                fecha: null,
                numero: ''
            },
            desvincularMode: false,
            isPlantaSelected: false,
            fechaFin: null,
            fechaInicio: null
        };
    },
    computed: {
        rol() {
            return utilsService.getRol();
        },
        filterTableData() {
            const searchTerm = this.search.toLowerCase();
            if (searchTerm == '') return this.tableData;
            return this.tableData.filter(item => item.material != null && (
                item.material.toLowerCase().includes(searchTerm) || item.empresa.toLowerCase().includes(searchTerm))
            );
        },
        isAllSelected() {
            return this.filterTableData.length > 0 && this.filterTableData.every(row => this.egresosSelected.includes(row.id));
        }
    },
    async beforeMount() {
        try {
            const grupo = this.$route.params.grupo;
            this.filter.grupoEstado = grupo;
            this.filter.estadoPago = this.$route.params.estado || null;
            this.materialOptions = await miscService.getMaterialesOptions();
            this.plantaOptions = await miscService.getPlantasByOptions();
            this.empresaOptions = await miscService.getEmpresasOptions();
            if (this.filter.grupoEstado == 4 || !this.filter.grupoEstado)
                this.estadoPagoOptions = await miscService.getEstadosOptions();
            await this.loadData();
        } catch (error) {
            console.error('Error fetching egresos:', error);
        }
    },
    methods: {
        async loadData() {
            
            this.filter.fechaInicio = this.filter.fechaInicio || null;
            this.filter.fechaFin = this.filter.fechaFin || null;
            const response = await egresoService.getAllFiltered(this.filter);
            this.tableData = response.data
            this.total = response.totalItem;
        },
        async changePage(page) {
            this.filter.page = page;
            await this.loadData();
        },
        async changePageSize(size) {
            this.filter.pageSize = size;
            this.filter.page = 1;
            await this.loadData();
        },
        async getAllFiltered() {
            if (this.exportMode) return;
            try {
                this.filter.page = 1;
                await this.loadData();
            } catch (error) {
                console.error("Error fetching data: ", error);
            }
        },
        selectionChange(rowId, event) {
            if (event.target.checked) {
                this.egresosSelected.push(rowId);
                const egreso = this.tableData.find(x => rowId == x.id);
                if (egreso)
                    this.egresosFactura.push(egreso);
            } else {
                this.deleteFromegresosSelected(rowId);
            }
        },
        isRowSelected(rowId) {
            return this.egresosSelected.includes(rowId);
        },
        toggleSelectAll(event) {
            if (event.target.checked) {
                if (this.desvincularMode)
                    this.egresosSelected = this.filterTableData.filter(row => row.urlFactura != null).map(row => row.id);
                else
                    this.egresosSelected = this.filterTableData.map(row => row.id);
                this.egresosFactura = this.tableData;

            } else {
                this.egresosSelected = [];
                this.egresosFactura = [];
            }
        },
        isMaterialValid() {
            let materiales = [...new Set(this.egresosFactura.map(item => item.materialID))];
            return materiales.length > 7 || materiales.length <= 0;
        },
        deleteFromegresosSelected(rowId) {
            this.egresosSelected = this.egresosSelected.filter(id => id !== rowId);
            this.egresosFactura = this.egresosFactura.filter(item => item.id !== rowId)
        },
        checkegresosValidos() {

            this.desvincularMode = !this.desvincularMode;
            if (this.desvincularMode && this.egresosSelected.length > 0)
                this.egresosSelected = this.filterTableData.filter(row => row.urlFactura != null).map(row => row.id);
            else {
                this.egresosSelected = [];
                this.egresosFactura = [];
            }
        },
        deleteRow(id) {
            Swal.fire({
                title: this.$t('estas_seguro'),
                text: this.$t('confirma_eliminar'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: this.$t('si_eliminar'),
                cancelButtonText: this.$t('cancelar')
            }).then(async (result) => {
                if (result.isConfirmed) {

                    Swal.fire({
                        html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">Eliminando...</h3>
                        </div>
                    </div>`,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    });

                    const response = await egresoService.deleteBy(id);
                    if (!response) {
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: this.$t('error'),
                        });
                        return;
                    }
                    await this.getAllFiltered();

                    Swal.fire({
                        text: this.$t('eliminado_correctamente'),
                        icon: "success",
                        showConfirmButton: false,
                        timer: 2000,
                        background: '#f8f9fa',
                        customClass: {
                            title: 'swal-title',
                            icon: 'swal-icon',
                        },
                    });
                }
            });

        },
        desvincularFactura() {
            Swal.fire({
                title: this.$t('estas_seguro'),
                text: 'Confirma si deseas desvincular la factura de los egresos seleccionados.',
                icon: 'warning',
                showCancelButton: true,
                cconfirmButtonText: this.$t('si_adjuntar'),
                cancelButtonText: this.$t('cancelar')
            }).then(async (result) => {
                if (result.isConfirmed) {

                    Swal.fire({
                        html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">${this.$t('guardando')}</h3>
                        </div>
                    </div>`,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    });

                    const response = await egresoService.delFactura(this.egresosSelected);
                    if (!response) {
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: this.$t('error')
                        });
                        return;
                    }
                    this.egresosSelected = [];
                    this.egresosFactura = [];
                    this.factura.file = null;
                    this.factura.fecha = null;
                    this.factura.numero = '';
                    this.desvincularMode = false;
                    await this.getAllFiltered();
                    this.$bvModal.hide('modal-factura');

                    Swal.fire({
                        title: this.$t('cambios_guardados'),
                        icon: "success",
                        showConfirmButton: false,
                        timer: 2000,
                        background: '#f8f9fa',
                        customClass: {
                            title: 'swal-title',
                            icon: 'swal-icon',
                        },
                    });
                }
            });
        },
        adjuntarFactura(event) {
            event.preventDefault();
            if (!this.factura || this.factura.file == null || this.factura.fecha == null || this.numero == '') {
                this.$toast.error('Por favor, completa los campos requeridos..', {
                    position: 'top-center',
                    timeout: 2000,
                    closeOnClick: true,
                    pauseOnHover: true
                });
                return;
            }

            if (this.isMaterialValid()) {
                this.$toast.error('Debes seleccionar por lo menos 1 material y máximo 7 distintos.', {
                    position: 'top-center',
                    timeout: 2000,
                    closeOnClick: true,
                    pauseOnHover: true
                });
                return;
            }

            Swal.fire({
                title: this.$t('estas_seguro'),
                text: this.$t('confirmar_factura'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: this.$t('si_adjuntar'),
                cancelButtonText: this.$t('cancelar')
            }).then(async (result) => {
                if (result.isConfirmed) {

                    Swal.fire({
                        html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">${this.$t('guardando')}</h3>
                        </div>
                    </div>`,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    });

                    const response = await egresoService.addFactura(this.egresosSelected, this.factura);
                    if (!response) {
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: this.$t('error')
                        });
                        return;
                    }
                    this.egresosSelected = [];
                    this.egresosFactura = [];
                    this.factura.file = null;
                    this.factura.fecha = null;
                    this.factura.numero = '';
                    await this.getAllFiltered();
                    this.$bvModal.hide('modal-factura');

                    Swal.fire({
                        title: this.$t('cambios_guardados'),
                        icon: "success",
                        showConfirmButton: false,
                        timer: 2000,
                        background: '#f8f9fa',
                        customClass: {
                            title: 'swal-title',
                            icon: 'swal-icon',
                        },
                    });
                }
            });
        },
        async onPlantaChange() {
            const planta = this.filter.planta;
            if (planta) {
                this.pasilloOptions = await miscService.getPasillosByPlantaOptions(planta);
                this.isPlantaSelected = true;
            } else {
                this.filter.pasillos = [];
                this.isPlantaSelected = false;
            }
        },
        async exportPagados() {
            try {
                Swal.fire({
                    html: `
                <div style="display: flex; align-items: center; justify-content: center;"> 
                  <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                  <div>
                    <h3 style="color: #006393;">`+ this.$t('generando_reporte') + `...</h3>
                  </div>
                </div>`,
                    showConfirmButton: false,
                    allowOutsideClick: false
                });
                await egresoService.getegresosPagados(this.fechaInicio, this.fechaFin);
                Swal.close();

            } catch {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: this.$t("error_exportar")
                });
                return;
            }
        },
        async cambiarModo() {
            Swal.fire({
                title: this.$t('estas_seguro'),
                text: this.$t('cancelar_vinculacion'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: this.$t('si'),
                cancelButtonText: this.$t('no')
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.egresosSelected = [];
                    this.egresosFactura = [];
                    this.facturaMode = false;
                }
            });
        }
    }
}
</script>
<style scoped>
button.btn.btn-secondary {
    vertical-align: super;

}

button.btn.btn-danger {
    vertical-align: super;
    float: right;
}

.mt-4,
.my-4 {
    margin-top: 1.8rem !important;
}
</style>